import React, { useContext } from "react";
import AsideBlock from "../AsideBlock";
import { Descriptions, Spin } from "antd";
import { InvigilationCtx } from "../../context";
import moment from "moment";
import { getNotJoinExamPeopleInfo } from "../../../../../service/exam";
import useExamInfo from "../../Hook/useExamInfo";

export default function ExamInfo() {
    const { currentData } = useContext(InvigilationCtx);
    const dateFormat = "MM-DD HH:mm";

    const [data, { loading }] = useExamInfo(
        getNotJoinExamPeopleInfo,
        currentData
    );

    return (
        <AsideBlock title="考核信息">
            <Spin spinning={loading}>
                <Descriptions
                    layout="vertical"
                    bordered
                    column={2}
                    size="small">
                    <Descriptions.Item label="考核名称">
                        {data?.examName}
                    </Descriptions.Item>
                    <Descriptions.Item label="考试时长">
                        {data?.duration}分钟
                    </Descriptions.Item>
                    <Descriptions.Item label="出题老师">
                        {data?.paperTeacherName} {data?.paperTeacherNo}
                    </Descriptions.Item>
                    <Descriptions.Item label="授课教师">
                        {data?.courseTeacherName} {data?.courseTeacherNo}
                    </Descriptions.Item>
                    <Descriptions.Item label="考试时间">
                        {moment(data?.beginTime).format(dateFormat)} -
                        {moment(data?.endTime).format(dateFormat)}
                    </Descriptions.Item>
                </Descriptions>
            </Spin>
        </AsideBlock>
    );
}
